__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "starterkit-mfehost-motifreact-ts-fabric";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.3.0", () => (Promise.all([__webpack_require__.e(8461), __webpack_require__.e(411)]).then(() => (() => (__webpack_require__(8461))))));
			register("@azure/msal-browser", "3.28.1", () => (Promise.all([__webpack_require__.e(4686), __webpack_require__.e(5644)]).then(() => (() => (__webpack_require__(4686))))));
			register("@ey/mfe-ui-core", "1.25.0", () => (Promise.all([__webpack_require__.e(1185), __webpack_require__.e(6493), __webpack_require__.e(4914), __webpack_require__.e(4751)]).then(() => (() => (__webpack_require__(1185))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(2456), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(2456))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(7465), __webpack_require__.e(2061)]).then(() => (() => (__webpack_require__(7465))))));
			register("react", "18.3.1", () => (__webpack_require__.e(9897).then(() => (() => (__webpack_require__(9897))))));
			initExternal(7762);
			initExternal(6348);
			initExternal(9858);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};